import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

import {
  CompanyAppsResponse,
  CountryResponse,
  CreateExternalUserRequest,
  ExternalUserResponse,
  StateResponse,
  UpdateExternalUserRequest,
  UserDetailsResponse
} from '../models/company-api.models';

/** Wraps the Company API (`companyApiUrl`). */
@Injectable({ providedIn: 'root' })
export class CompanyApiService {
  private readonly http = inject(HttpClient);

  private url(path: string): string {
    return `${environment.companyApiUrl}/${path}`;
  }

  getUserDetails(userId: number): Observable<UserDetailsResponse> {
    return this.http.get<UserDetailsResponse>(this.url(`Users/${userId}`));
  }

  /** Apps provisioned to the company — decides which sales channels items can use. */
  getCompanyApps(companyId: number): Observable<CompanyAppsResponse> {
    return this.http.get<CompanyAppsResponse>(this.url(`Companies/${companyId}/Apps`));
  }

  createExternalUser(request: CreateExternalUserRequest): Observable<ExternalUserResponse> {
    return this.http.post<ExternalUserResponse>(this.url('ExternalUsers'), request);
  }

  updateExternalUser(id: number, request: UpdateExternalUserRequest): Observable<void> {
    return this.http.put<void>(this.url(`ExternalUsers/${id}`), request);
  }

  getCountries(): Observable<CountryResponse[]> {
    return this.http.get<CountryResponse[]>(this.url('Countries'));
  }

  getStates(countryId: number): Observable<StateResponse[]> {
    return this.http.get<StateResponse[]>(this.url(`States?CountryId=${countryId}`));
  }
}
